// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "e49664b-dirty",
    "hash": "e49664b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "e49664b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
